import { Helmet } from 'react-helmet-async';
import PageHeader from 'app/design/speedBot/PageHeader';
import { decodeUrlData } from 'utils/GenericFunctions';
import { useHistory, useParams } from 'react-router-dom';
import { PAGES } from 'app/components/Common/Breadcrumb/types';
import Breadcrumbs from 'app/design/uiComponents/Breadcrumbs';
import { useQuery } from 'react-query';
import {
  Errors,
  GetMarketplaceBotsByCategoryResult,
} from 'types/ApiServicesTypes';
import { GetMarketplaceBotsByCategory } from 'services/apiServices';
import MarketplaceItems from 'app/design/itemsComponent/MarketplaceItems';
import { Box, Grid } from '@mui/material';
import CircularLoader from 'app/design/uiComponents/CircularLoader';

export function TradersCategoryPage() {
  const { id, title, subtitle } =
    useParams<{ id: string; title: string; subtitle: string }>();
  const history = useHistory();

  const query = useQuery<GetMarketplaceBotsByCategoryResult, Errors>(
    ['GetTradersBotsByCategory', 'traders', parseInt(id)],
    () => GetMarketplaceBotsByCategory('traders', 'GET', parseInt(id)),
  );
  const { data: marketplaceBotsData, isLoading } = query;

  const marketplaceBots =
    marketplaceBotsData &&
    marketplaceBotsData.length > 0 &&
    marketplaceBotsData[0].bots &&
    marketplaceBotsData[0].bots.length > 0
      ? marketplaceBotsData[0].bots
      : null;

  return (
    <>
      <Helmet>
        <title>Search Traders</title>
        <meta name="description" content="Search Traders Page" />
      </Helmet>
      <CircularLoader open={isLoading} />
      <PageHeader
        variant="inactive"
        buttonText={decodeUrlData(title)}
        title={decodeUrlData(subtitle)}
        buttonHandleClick={() => history.goBack()}
        breadcrumb={<Breadcrumbs page={PAGES.TRADERS_CATEGORY} data={{}} />}
      />
      <Box
        sx={{ display: 'flex', justifyContent: 'center' }}
        className="p-main-spacing"
      >
        <Grid
          container
          spacing={2}
          sx={{
            maxWidth: { xs: '32rem', md: '50rem' },
            flex: { lg: 1, xl: 1 },
            py: 2,
          }}
        >
          {marketplaceBots && (
            <MarketplaceItems
              bots={marketplaceBots}
              isGraph={true}
              isSearch={true}
              isTrader={true}
            />
          )}
        </Grid>
      </Box>
    </>
  );
}
